export default __webpack_public_path__ + "static/media/lead_dell.633fbbd5.png";